export function login({ accessToken, userId }: { accessToken: string; userId: string }): void {
  if (accessToken && userId) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('userId', userId);
  }
}

export function getAccessToken(): string | null {
  return localStorage.getItem('accessToken');
}

export function getUserId(): string | null {
  return localStorage.getItem('userId');
}

export function isLoggedIn(): boolean {
  return !!getAccessToken() && !!getUserId();
}

export function logOut(): void {
  localStorage.clear();
  window.location.reload();
}

export function setRedirectAfterAuth(path: string): void {
  sessionStorage.setItem('redirectAfterAuth', path);
}

export function getRedirectAfterAuth(): string | null {
  return sessionStorage.getItem('redirectAfterAuth');
}

export function clearRedirectAfterAuth(): void {
  sessionStorage.removeItem('redirectAfterAuth');
}

export function setUserComeFromApp() {
  localStorage.setItem('userComeFromApp', 'true');
}

export function isUserComeFromApp(): boolean {
  return localStorage.getItem('userComeFromApp') === 'true';
}
